/* components/labels/EditLabel.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_input_value,
	set_style,
	space,
	text
} from "svelte/internal";

import { createEventDispatcher } from "svelte";

function create_fragment(ctx) {
	let div2;
	let dl0;
	let dt0;
	let dd0;
	let input0;
	let t2;
	let dl1;
	let dt1;
	let dd1;
	let input1;
	let t5;
	let dl2;
	let dt2;
	let dd2;
	let div0;
	let input2;
	let t8;
	let div1;
	let button0;
	let t10;
	let button1;
	let t11;
	let button1_disabled_value;
	let dispose;

	return {
		c() {
			div2 = element("div");
			dl0 = element("dl");
			dt0 = element("dt");

			dt0.innerHTML = `<label class="f5 text-bold" for="label-name">Label name</label> 
    `;

			dd0 = element("dd");
			input0 = element("input");
			t2 = space();
			dl1 = element("dl");
			dt1 = element("dt");

			dt1.innerHTML = `<label class="f5 text-bold" for="label-description">Description</label> 
    `;

			dd1 = element("dd");
			input1 = element("input");
			t5 = space();
			dl2 = element("dl");
			dt2 = element("dt");

			dt2.innerHTML = `<label class="f5 text-bold" for="label-colour">Colour</label> 
    `;

			dd2 = element("dd");
			div0 = element("div");
			input2 = element("input");
			t8 = space();
			div1 = element("div");
			button0 = element("button");
			button0.textContent = "Cancel";
			t10 = space();
			button1 = element("button");
			t11 = text("Save changes");
			attr(dt0, "class", "mb-0 d-flex flex-justify-between flex-items-center");
			attr(input0, "class", "form-control");
			attr(input0, "id", "label-name");
			attr(input0, "type", "text");
			attr(input0, "placeholder", "Label name");
			attr(input0, "autocomplete", "off");
			attr(dd0, "class", "position-relative");
			attr(dl0, "class", "form-group col-3 pr-3");
			attr(dt1, "class", "d-flex flex-justify-between flex-items-center mb-0");
			attr(input1, "class", "form-control width-full");
			attr(input1, "id", "label-description");
			attr(input1, "type", "text");
			attr(input1, "placeholder", "Description (optional)");
			attr(input1, "autocomplete", "off");
			attr(dl1, "class", "form-group flex-auto pr-3");
			attr(dt2, "class", "mb-0");
			attr(input2, "class", "form-control");
			attr(input2, "id", "label-colour");
			attr(input2, "type", "color");
			set_style(input2, "width", "6em");
			attr(div0, "class", "position-relative");
			attr(dl2, "class", "form-group");
			attr(button0, "class", "btn");
			attr(button0, "type", "button");
			attr(button1, "class", "btn btn-primary");
			attr(button1, "type", "submit");
			button1.disabled = button1_disabled_value = !/*valid*/ ctx[3];
			attr(div1, "class", "form-group ml-5");
			attr(div2, "class", "Box-row border-top-0 m-0 pt-0 pb-0 d-flex flex-items-end");
		},
		m(target, anchor, remount) {
			insert(target, div2, anchor);
			append(div2, dl0);
			append(dl0, dt0);
			append(dl0, dd0);
			append(dd0, input0);
			set_input_value(input0, /*name*/ ctx[0]);
			append(div2, t2);
			append(div2, dl1);
			append(dl1, dt1);
			append(dl1, dd1);
			append(dd1, input1);
			set_input_value(input1, /*description*/ ctx[1]);
			append(div2, t5);
			append(div2, dl2);
			append(dl2, dt2);
			append(dl2, dd2);
			append(dd2, div0);
			append(div0, input2);
			set_input_value(input2, /*colour*/ ctx[2]);
			append(div2, t8);
			append(div2, div1);
			append(div1, button0);
			append(div1, t10);
			append(div1, button1);
			append(button1, t11);
			if (remount) run_all(dispose);

			dispose = [
				listen(input0, "input", /*input0_input_handler*/ ctx[7]),
				listen(input1, "input", /*input1_input_handler*/ ctx[8]),
				listen(input2, "input", /*input2_input_handler*/ ctx[9]),
				listen(button0, "click", /*click_handler*/ ctx[10]),
				listen(button1, "click", /*handleSave*/ ctx[5])
			];
		},
		p(ctx, [dirty]) {
			if (dirty & /*name*/ 1 && input0.value !== /*name*/ ctx[0]) {
				set_input_value(input0, /*name*/ ctx[0]);
			}

			if (dirty & /*description*/ 2 && input1.value !== /*description*/ ctx[1]) {
				set_input_value(input1, /*description*/ ctx[1]);
			}

			if (dirty & /*colour*/ 4) {
				set_input_value(input2, /*colour*/ ctx[2]);
			}

			if (dirty & /*valid*/ 8 && button1_disabled_value !== (button1_disabled_value = !/*valid*/ ctx[3])) {
				button1.disabled = button1_disabled_value;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div2);
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { label } = $$props;
	const dispatch = createEventDispatcher();
	let name = label.name;
	let description = label.description;
	let colour = label.colour;
	let valid = true;
	const handleSave = () => dispatch("save", { name, description, colour });

	function input0_input_handler() {
		name = this.value;
		$$invalidate(0, name);
	}

	function input1_input_handler() {
		description = this.value;
		$$invalidate(1, description);
	}

	function input2_input_handler() {
		colour = this.value;
		$$invalidate(2, colour);
	}

	const click_handler = () => dispatch("cancel");

	$$self.$set = $$props => {
		if ("label" in $$props) $$invalidate(6, label = $$props.label);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*name, colour*/ 5) {
			$: {
				$$invalidate(3, valid = true);

				if (!name) {
					$$invalidate(3, valid = false);
				}

				if (!colour) {
					$$invalidate(3, valid = false);
				}
			}
		}
	};

	return [
		name,
		description,
		colour,
		valid,
		dispatch,
		handleSave,
		label,
		input0_input_handler,
		input1_input_handler,
		input2_input_handler,
		click_handler
	];
}

class EditLabel extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { label: 6 });
	}
}

export default EditLabel;